module.exports = __webpack_public_path__ + "static/img/typograph@t.768142c.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/typograph@t.gif
// module id = gQCM
// module chunks = 0